"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributorProductWithOffers = void 0;
var get_distributor_product_with_offers_1 = require("./get-distributor-product-with-offers");
Object.defineProperty(exports, "getDistributorProductWithOffers", { enumerable: true, get: function () { return get_distributor_product_with_offers_1.getDistributorProductWithOffers; } });
